<template>      
  <v-content> 
    <v-container fluid style="padding-bottom:55px">
      <page-header v-if="!$route.meta.breadcrumb"></page-header>                    
      <router-view />                                                              
    </v-container>
    <v-footer :color="$config.theme.primaryColor" dark style="position:absolute; bottom:0; width:100%">
      <span class="caption">
        {{footerCopyright}}
      </span> 
      <div class="spacer"></div> 
      <span class="caption mr-1 d-none d-sm-flex"> {{footerTagline}} </span> 
      <i aria-hidden="true" class="v-icon pink--text material-icons" style="font-size: 20px;">{{footerIcon}}</i>
    </v-footer>
  </v-content>      
</template>

<script>
import PageHeader from './PageHeader';


export default {
  name: 'app-content',
  components: { 
    PageHeader,           
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 60
    },
    footerCopyright: 'Survey Team © 2020',
    footerTagline  : 'Riset & Konsultan',
    footerIcon     : 'android',    
  }),

  methods: {
   
  }
};
</script>
